import { useQuery } from '@tanstack/react-query';
import { camelizeKeys, decamelizeKeys } from 'humps';

import { useApiClient } from '../../../hooks';

const useGetSourcesQuery = (accessToken, organizationId) => {
  const apiClient = useApiClient(accessToken);
  const query = useQuery({
    queryKey: ['sync', 'sources'],
    queryFn: async () => {
      const { data } = await apiClient.get('/sync/sources', {
        params: decamelizeKeys({ organizationId })
      });
      return camelizeKeys(data);
    },
    retry: false,
    enabled: Boolean(accessToken) && Boolean(organizationId)
  });

  return query;
};

export { useGetSourcesQuery };
